export type FilterTarget = 'url_parameter' | 'url_path' | 'website'

export type FilterComparator =
  | 'equals'
  | 'not_equals'
  | 'contains'
  | 'does_not_contain'
  | 'starts_with'
  | 'ends_with'

export interface FilterRule {
  id: string
  target: FilterTarget
  parameter_name: string
  comparator: FilterComparator
  value: string
  ordinal: number
}

export const filterTargetOptions: { value: FilterTarget; label: string }[] = [
  { value: 'url_parameter', label: 'URL Parameter' },
  { value: 'url_path', label: 'URL Path' },
  { value: 'website', label: 'Website' },
]

export const filterComparatorOptions: {
  value: FilterComparator
  label: string
}[] = [
  { value: 'equals', label: 'Equals' },
  { value: 'not_equals', label: 'Not equals' },
  { value: 'contains', label: 'Contains' },
  { value: 'does_not_contain', label: 'Does not contain' },
  { value: 'starts_with', label: 'Starts with' },
  { value: 'ends_with', label: 'Ends with' },
]

export const filterParameterOptions = [
  { value: 'aff_id', label: 'aff_id' },
  { value: 'utm_campaign', label: 'utm_campaign' },
  { value: 'sub1', label: 'sub1' },
  { value: 'sub2', label: 'sub2' },
  { value: 'sub3', label: 'sub3' },
  { value: 'sub4', label: 'sub4' },
  { value: 'sub5', label: 'sub5' },
] as const

export interface TestFlowMetrics {
  cvr: string | null
  ltc: string | null
  cpa: string | null
  lead_count: number
  visitor_count: number
  growth: number
}

export interface Test {
  id: string
  name: string
  type: string
  base_flow: {
    id: number
    name: string
    slug: string
    template_slug: string
    metrics?: TestFlowMetrics
    [key: string]: unknown
  } | null
  flows: {
    id: number
    flow: {
      id: number
      name: string
      slug: string
      template_slug: string
      metrics?: TestFlowMetrics
      [key: string]: unknown
    } | null
    traffic_percentage: number
  }[]
  triggers: FilterRule[]
  metrics?: TestFlowMetrics
  status: 'active' | 'paused' | 'archived'
  created_at: string
}

export const mockTests: Test[] = [
  {
    id: '1',
    name: 'Test 1',
    type: 'lead_flow',
    base_flow: {
      id: 1,
      name: 'Flow 1',
      slug: 'flow-1',
      template_slug: 'savings-estimates',
    },
    flows: [
      {
        id: 1,
        flow: {
          id: 2,
          name: 'Finding Assistance Flow',
          slug: 'finding-assistance-1',
          template_slug: 'finding-assistance',
        },
        traffic_percentage: 50,
      },
    ],
    triggers: [
      {
        id: 't1-1',
        target: 'url_parameter',
        parameter_name: 'utm_source',
        comparator: 'equals',
        value: 'facebook',
        ordinal: 0,
      },
    ],
    metrics: {
      cvr: '15.2',
      ltc: '2.8',
      cpa: '3',
      lead_count: 4320,
      visitor_count: 28420,
      growth: 8,
    },
    status: 'paused',
    created_at: '2024-01-15',
  },
  {
    id: '2',
    name: 'Test 2',
    type: 'lead_flow',
    base_flow: {
      id: 2,
      name: 'Finding Assistance Flow',
      slug: 'finding-assistance-1',
      template_slug: 'finding-assistance',
    },
    flows: [
      {
        id: 2,
        flow: {
          id: 1,
          name: 'Flow 1',
          slug: 'flow-1',
          template_slug: 'savings-estimates',
        },
        traffic_percentage: 33,
      },
      {
        id: 3,
        flow: {
          id: 3,
          name: 'Flow 3',
          slug: 'flow-3',
          template_slug: 'savings-estimates',
        },
        traffic_percentage: 34,
      },
    ],
    triggers: [
      {
        id: 't2-1',
        target: 'url_path',
        parameter_name: '',
        comparator: 'contains',
        value: '/landing',
        ordinal: 0,
      },
      {
        id: 't2-2',
        target: 'url_parameter',
        parameter_name: 'ref',
        comparator: 'does_not_contain',
        value: 'organic',
        ordinal: 1,
      },
    ],
    metrics: {
      cvr: '11.0',
      ltc: '3.5',
      cpa: '4',
      lead_count: 2150,
      visitor_count: 19545,
      growth: -1,
    },
    status: 'paused',
    created_at: '2024-01-20',
  },
]
